<template>
    <div>
        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
            <!-- DESCRIPCION -->
            <div class="field col-12">
                <span class="p-float-label">
                    <InputText v-model="nomina.descripcion" type="text"/>
                    <label>Descripción</label>
                </span>
            </div>
            <!-- REGIMEN -->
            <div class="field col-12">
                <span class="p-float-label">
                    <Dropdown style="text-align: left" v-model="nomina.tipoRegimen" :options="tipoRegimen" optionLabel="tipoRegimen" />
                    <label>Tipo de Régimen</label>
                </span>
            </div>
            <!-- NO NOMINA -->
            <div class="field col-12 md:col-2">
                <span class="p-float-label">
                    <InputText v-model="nomina.noNomina" type="text"/>
                    <label>No. Nómina</label>
                </span>
            </div>
            <!-- TIPO DE NOMINA -->
            <div class="field col-12 md:col-4">
                <span class="p-float-label">
                    <Dropdown style="text-align: left" v-model="nomina.tipoNomina" :options="tipoNomina" optionLabel="tipoNomina" />
                    <label>Tipo de Nómina</label>
                </span>
            </div>
            <!-- PERIODICIDAD DE PAGO -->
            <div class="field col-12 md:col-4">
                <span class="p-float-label">
                    <Dropdown style="text-align: left" v-model="nomina.periodicidadPago" :options="periodicidadPago" optionLabel="periodicidadPago" />
                    <label>Periodicidad de Pago</label>
                </span>
            </div>
            <!-- SERIE -->
            <div class="field col-12 md:col-2">
                <span class="p-float-label">
                    <Dropdown style="text-align: left" v-model="nomina.serie" :options="serie" :editable="true" />
                    <label>Serie</label>
                </span>
            </div>
            <!-- FECHA DE PAGO -->
            <div class="field col-12 md:col-4">
                <span class="p-float-label">
                    <Calendar v-model="nomina.fechaPago" dateFormat="dd-MM-yy" />
                    <label>Fecha de Pago</label>
                </span>
            </div>
            <!-- FECHA INICIAL -->
            <div class="field col-12 md:col-4">
                <span class="p-float-label">
                    <Calendar v-model="nomina.fechaInicialPago" dateFormat="dd-MM-yy" />
                    <label>Fecha Inicial</label>
                </span>
            </div>
            <!-- FECHA FINAL -->
            <div class="field col-12 md:col-4">
                <span class="p-float-label">
                    <Calendar v-model="nomina.fechaFinalPago" dateFormat="dd-MM-yy" />
                    <label>Fecha Final</label>
                </span>
            </div>
        </div>
        <DataTable :value="itemsNomina" responsiveLayout="scroll" ref="dt">
            <template #header>
                <div>Nómina</div>
            </template>
            <Column v-for="col of columnsNomina" :field="col.field" :header="col.header"></Column>
        </DataTable>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        components: {
                       
        },
        data() {
            return {
                columnsNomina: [],
                itemsNomina: [],
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
            nomina(){
                return this.$store.state.nominaStore;
            },

            tipoRegimen(){
                return this.$store.state.tipoRegimenStore;
            },

            tipoNomina(){
                return this.$store.state.tipoNominaStore;
            },
            
            periodicidadPago(){
                return this.$store.state.periodicidadPagoStore;
            },
            
            serie(){
                let serie_ = [];
                return serie_
            },
            
        },
        created() {

        },
        methods: {
        
        },
    }
    </script>
    <style>

    </style>